
import "./ContactUs.css";
import ContactForm from "./ContactUs/ContactForm";
import OfficeLocation from "./ContactUs/OfficeLocation";
export default function ContactUs() {
  return (
    <div className="contact-us">
     <ContactForm />
     <OfficeLocation />
    </div>
  );
}
